import { useNavigate } from 'react-router-dom';
import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import { useTunnelDispatch } from '../../context/TunnelContext';
import arkoseLogo from '../../assets/arkose-logo.png';
import gpLogo from '../../assets/gp-logo.svg';

export default function TunnelSelection() {
  const navigate = useNavigate();
  const dispatch = useTunnelDispatch();

  function handleStartResoling() {
    dispatch({ type: 'RESET_ORDER' });
    navigate('/nouvelle-demande/marque');
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
        gap: 4,
      }}
    >
      <Stack alignItems="center" spacing={2} sx={{ width: '100%', maxWidth: 420 }}>
        <Box
          component="img"
          src={arkoseLogo}
          alt="Arkose"
          sx={{ width: '100%' }}
        />
        <Stack direction="row" alignItems="center" spacing={2} sx={{ width: '70%' }}>
          <Divider sx={{ flex: 1 }} />
          <Typography variant="body1" color="text.secondary">
            x
          </Typography>
          <Divider sx={{ flex: 1 }} />
        </Stack>
        <Box
          component="img"
          src={gpLogo}
          alt="Galoche & Patin"
          sx={{ width: '45%' }}
        />
      </Stack>
      <Stack spacing={3} sx={{ width: '100%', maxWidth: 480 }}>
        <Button size="large" variant="contained" onClick={handleStartResoling}>
          Ressemeler mes chaussons
        </Button>
        <Button
          size="large"
          variant="outlined"
          onClick={() => navigate('/suivre-commande')}
        >
          Suivre ma commande
        </Button>
      </Stack>
    </Box>
  );
}
